// extracted by css-extract-rspack-plugin
export default {"cls1":"AffiliationPrompt-cls1_ITl","cls2":"AffiliationPrompt-cls2_qzr AffiliationPrompt-cls1_ITl"};